<template>
  <v-app id="app">
    <section class="bg-primary">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" md="3" lg="2">
            <v-app-bar-nav-icon
                @click.stop="drawer = !drawer"
                class="hidden-md-and-up float-left"
                color="white"
            ></v-app-bar-nav-icon>

            <v-navigation-drawer app v-model="drawer">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <h1>Rede Governo de Serviços do Amazonas</h1>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list dense nav>
                <v-list-item v-for="item in items" :key="item.title" link :href="item.href">
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>

            <router-link to="/">
              <v-img
                  id="logo"
                  src="https://apstatic.prodam.am.gov.br/images/rede_governo/logo-rede-governo-contraste.svg"
                  height="68"
                  contain
                  alt="Logo Rede Governo do Amazonas de Serviços">
              </v-img>
            </router-link>
          </v-col>
          <v-col cols="12" md="9" lg="10" class="d-none d-md-block align-self-end pb-4 text-right">
            <div id="nav">
              <a href="https://acesso.redegoverno.am.gov.br/auth/realms/am/login-actions/reset-credentials?client_id=conta"
                 class="white--text text-decoration-none pa-2">Alterar Senha</a>
              <a @click="logout" class="white--text text-decoration-none pa-2 mr-6">Sair</a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <router-view/>

    <v-footer color="grey lighten-4" class="pt-8 pb-12 px-0 footer-bottom">
      <div class="bg-wave-graphics right"></div>
      <v-container class="py-0">
        <v-row class="text-center py-6">

          <v-col cols="6" sm="3" md="2" offset-md="2" class="py-0">
            <img id="logo-redegov-footer"
                 src="https://apstatic.prodam.am.gov.br/images/rede_governo/logo-rede-governo.svg"
                 alt="Logo Rede Governo de Serviços do Amazonas">
          </v-col>
          <v-col cols="6" sm="4" md="2" class="py-0 align-self-center">
            <img id="logo-gov-footer"
                 src="https://apstatic.prodam.am.gov.br/images/logo_governo/logo-gov-horizontal.svg"
                 alt="Logo Governo do Amazonas">
          </v-col>

          <v-col cols="12" sm="5" md="4" class="pt-2 align-self-center">
            <p class="text-center text-12 mb-0" style="width: 260px">Copyright © 2020 Governo do Estado do Amazonas.
              Todos os direitos reservados</p>
          </v-col>

        </v-row>

      </v-container>
      <div class="bg-wave-graphics left d-none d-md-block"></div>
    </v-footer>

  </v-app>
</template>

<script>


import {mapGetters} from "vuex";

export default {
  name: 'App',
  data: () => ({

    drawer: false,
    items: [
      {title: 'Início', icon: 'mdi-home', href: '/'},
      {
        title: 'Alterar Senha',
        icon: 'mdi-lock',
        href: 'https://acesso.redegoverno.am.gov.br/auth/realms/am/login-actions/reset-credentials?client_id=conta'
      },
      {title: 'Sair', icon: 'mdi-logout', href: process.env.VUE_APP_URL_PORTAL},

    ],
    right: null,
  }),
  computed: {
    ...mapGetters({
      cidadao: 'cidadao/cidadao'
    })
  },
  created() {
    this.getCidadao();
  },
  methods: {
    async getCidadao() {
      try{
        await this.$store.dispatch('cidadao/loadCidadao');
      }catch (erro){
        console.log(erro)
      }
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$keycloak.logout();
    }
  }
};
</script>
